import { Add, Remove } from "@mui/icons-material";
import { Box, InputAdornment, TextField } from "@mui/material";
import { GetData } from "contexts/DataContext";
import React from "react";
import Repeatable from "react-repeatable";

export function RateField(props) {
  const { dataObj, forceSetDataObj } = GetData();

  const [rate, setRate] = React.useState(Number(dataObj?.refreshRate || "3"));

  React.useEffect(() => {
    setRate(Number(dataObj?.refreshRate || "3"));
  }, [dataObj?.refreshRate]);

  function changeRate(add, save = false) {
    let currentRate = rate;
    let newRate = 0;
    if (add) {
      newRate = currentRate + 1;
    } else if (currentRate > 3) {
      newRate = currentRate - 1;
    } else {
      newRate = currentRate;
    }
    setRate(newRate);
    save && forceSetDataObj(newRate, "refreshRate");
  }

  if (dataObj?.payType === "self-service") {
    return;
  }
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        width: "100%",
      }}
    >
      <TextField
        InputProps={{
          disabled: true,
          endAdornment: (
            <InputAdornment
              onClick={(e) => {
                changeRate(true, true);
              }}
              position="end"
            >
              <Repeatable
                onHold={() => {
                  changeRate(true);
                  // Callback fired mutiple times while holding down.
                }}
                onHoldEnd={() => {
                  forceSetDataObj(rate, "refreshRate");
                }}
              >
                <Add />
              </Repeatable>
            </InputAdornment>
          ),
          startAdornment: (
            <InputAdornment
              onClick={(e) => {
                changeRate(false, true);
              }}
              position="start"
            >
              <Repeatable
                onHold={() => {
                  changeRate(false);
                  // Callback fired mutiple times while holding down.
                }}
                onHoldEnd={() => {
                  forceSetDataObj(rate, "refreshRate");
                }}
              >
                <Remove />
              </Repeatable>
            </InputAdornment>
          ),
          style: {
            // fontSize: dataObj?.deviceWidth?.isMobile
            //   ? "0.875rem"
            //   : "1rem",
          },
        }}
        id="input-rate"
        // fullWidth
        inputProps={{
          maxLength: 3,
          style: { textAlign: "center" },
        }}
        label={"Частота получения QR"}
        mb={2}
        mt={2}
        name="rate"
        // onChange={(e) =>
        //   forceSetDataObj(
        //     e.target.value?.replace(/\D/g, ""),
        //     "refreshRate"
        //   )
        // }
        // placeholder="Установите частоту обновления данных"
        sx={{
          margin: "0.875rem 0",
          // width: "180px",
          textAlign: "center !important",
        }}
        type="text"
        value={rate ? rate + " cек." : "10 сек."}
        variant="standard"
      />
    </Box>
  );
}
